/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

var isString = require( '@stdlib/assert-is-string' ).isPrimitive;
var isFunction = require( '@stdlib/assert-is-function' );
var format = require( '@stdlib/string-format' );


// MAIN //

/**
* Attempts to parse a string as JSON.
*
* @param {string} str - string to parse
* @param {Function} [reviver] - transformation function
* @throws {TypeError} first argument must be a string
* @throws {TypeError} reviver must be a function
* @returns {(*|Error)} parsed value or parse error
*
* @example
* var obj = parseJSON( '{"beep":"boop"}' );
* // returns {'beep':'boop'}
*/
function parseJSON( str, reviver ) {
	if ( !isString( str ) ) {
		throw new TypeError( format( 'invalid argument. First argument must be a string. Value: `%s`.', str ) );
	}
	if ( arguments.length > 1 ) {
		if ( !isFunction( reviver ) ) {
			throw new TypeError( format( 'invalid argument. Reviver argument must be a function. Value: `%s`.', reviver ) );
		}
	}
	try {
		return JSON.parse( str, reviver );
	} catch ( error ) {
		return error;
	}
}


// EXPORTS //

module.exports = parseJSON;
